/* FAQ topic filter.
 *
 * This used to be marked up as an ARIA tab set, but it never was one: the "All"
 * control showed every section at once, so it had no single tabpanel to own. That
 * is the PowerMapper finding from the Sept 2026 audit ("every active role=tab
 * element must have a corresponding role=tabpanel element").
 *
 * A set of toggle buttons is what this control actually is, so it is marked up as
 * one: each button reports its own state with aria-pressed, and the sections keep
 * their own headings as the page structure. No tab roles, nothing to mismatch.
 */

function initializeFaqs() {
  const sections = document.querySelectorAll('.collapsible-content');
  const sidebar = document.querySelector('.sidebar');
  if (!sidebar) return;

  const sectionNav = document.createElement('ul');
  sectionNav.classList.add('list-unstyled');

  const sectionNavItemAll = document.createElement('li');
  sectionNavItemAll.innerHTML = `<button class="faq-nav-item link link--text list-menu__item list-menu__item--link button" type="button" aria-pressed="true" data-target="all">All</button>`;
  sectionNav.appendChild(sectionNavItemAll);

  sections.forEach((section) => {
    const headingItem = section.querySelector('.collapsible-content__heading');
    const headingId = section.getAttribute('data-heading');
    section.setAttribute('id', `faq-section-${headingId}`);

    const sectionNavItem = document.createElement('li');
    sectionNavItem.innerHTML = `<button class="faq-nav-item link link--text list-menu__item list-menu__item--link" type="button" id="faq-filter-${headingId}" aria-pressed="false" aria-controls="faq-section-${headingId}" data-target="${headingId}">${headingItem.innerHTML}</button>`;
    sectionNav.appendChild(sectionNavItem);
  });

  sidebar.appendChild(sectionNav);
  initializeFaqLinks();
}

function initializeFaqLinks() {
  const links = document.querySelectorAll('.faq-nav-item');
  const sections = document.querySelectorAll('.collapsible-content');

  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      const target = e.currentTarget.getAttribute('data-target');

      links.forEach((l) => {
        l.classList.remove('button');
        l.setAttribute('aria-pressed', 'false');
      });
      e.currentTarget.classList.add('button');
      e.currentTarget.setAttribute('aria-pressed', 'true');

      if (target === 'all') {
        sections.forEach((section) => {
          section.classList.remove('hidden');
        });
      } else {
        sections.forEach((section) => {
          section.classList.add('hidden');
        });
        document.querySelector(`[data-heading="${target}"]`).classList.remove('hidden');
      }
    });
  });
}

window.addEventListener('DOMContentLoaded', () => {
  initializeFaqs();
});
